<template>
    <div class="checkbox-filter" :class="{ 'checkbox-filter--horizontal': horizontal }">
        <ul class="checkbox-filter__list">
            <li v-for="(option, index) in options" :key="index" class="checkbox-filter__item">
                <Checkbox
                    v-model="filter"
                    :value="getOptionValue(option)"
                    :size="compact ? 'small' : ''"
                    theme="inverted"
                    :disabled="checkDisabled(option)"
                >
                    <slot :option="option">
                        <span>{{ getOptionText(option) }}</span>
                    </slot>
                </Checkbox>
            </li>
        </ul>
    </div>
</template>

<script>
import { Checkbox } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'CheckboxFilter',
    components: {
        Checkbox
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
        viewLabel: {
            type: String,
            default: undefined
        },
        emitProp: {
            type: String,
            default: undefined
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        isDisabled: {
            type: Function,
            validator: () => true,
            default: () => false
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            filter: []
        };
    },
    watch: {
        filter: {
            handler(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    created() {
        this.filter = this.modelValue;
    },
    methods: {
        getOptionText(option) {
            if (this.viewLabel) return option[this.viewLabel];

            return option;
        },
        getOptionValue(option) {
            if (this.emitProp) return option[this.emitProp];

            return option;
        },
        checkDisabled(option) {
            return this.isDisabled(option);
        }
    }
};
</script>

<style lang="scss" src="./CheckboxFilter.scss"></style>
